import axiosInstance from "./axiosInstance";

export const fetchSubscriptionPackages = () => axiosInstance.get("/superadmin/subscription-packages");

export const createSubscriptionPackage = (data) => axiosInstance.post("/superadmin/subscription-packages", data);

export const updateSubscriptionPackage = (id, data) => axiosInstance.put(`/superadmin/subscription-packages/${id}`, data);

export const deleteSubscriptionPackage = (id) => axiosInstance.delete(`/superadmin/subscription-packages/${id}`);
